// Centralized constants - BD framework (11 stages)
export const STAGES = [
  "Cold Lead",
  "Contacted - No Response",
  "Nurture - Early Interest",
  "Nurture - Needs Support",
  "Warm - Meeting Completed",
  "Hot - Agreement Pending",
  "Agreement Signed",
  "Activating",
  "Activated",
  "Lost - Not Interested",
  "Lost - Not Qualified",
];

export const ACTIVE_PIPELINE_STAGES = [
  "Nurture - Early Interest",
  "Nurture - Needs Support",
  "Warm - Meeting Completed",
  "Hot - Agreement Pending",
];

export const ACTIVITY_TYPES = [
  "Warm Intro",
  "Cold Email",
  "Phone Call",
  "Meeting",
  "Consultation",
  "Assessment",
  "LOI Sent",
  "LOI Signed",
  "Follow-up",
  "Other",
];

export const PRIORITIES = ["High", "Medium", "Low"];
export const BD_STATUSES = ["Active", "Pending", "Stalled", "Archived"];
